<div class="l-d-f l-jc-cen l-ai-cen">
  <div class="mirror-rotate-h">
    <cds-icon [config]="iconConfig" icon="form:search" [ngStyle]="{ '--cds-icon-color': '#8E90A2' }"></cds-icon>
  </div>
  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  <span class="cds-h2-light font-dark-navy l-ma-0">{{ msg || 'common.noResultFound' | lang }}</span>
</div>
